export function variationName(name, value) {
  var valuePortion = typeof value === 'number' ? String(value) : "".concat(value[0].toUpperCase()).concat(value.substring(1));
  return "".concat(name).concat(valuePortion);
}